import { ValidationRules } from "../../../types/entrypoint";

export const isValidFormValue = (
  value: string,
  required: boolean,
  validationRules: Partial<ValidationRules>,
  type: keyof ValidationRules,
): boolean => {
  const validationRule = validationRules[type];
  const emptyAndRequired = !value && required;
  return (
    !emptyAndRequired &&
    (!validationRule || !value || RegExp(validationRule).test(value))
  );
};
